import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../config/axios';
import { v4 as uuidv4 } from 'uuid';

// Save user-game
export const createUser = createAsyncThunk(
  'users/createUser',
  async (
    { formData, segment, survey_step1, survey_step2, survey_step3, answers, points },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.post('/', {
        ...formData,
        segment,
        survey_step1,
        survey_step2,
        survey_step3,
        answers,
        points,
      });
      //console.log(response);
      return response;
    } catch (error) {
      //console.log(error.response);
      return rejectWithValue(error.response);
    }
  }
);

// Get all existing users
export const getAllUsers = createAsyncThunk('users/getAllUsers', async (rejectWithValue) => {
  try {
    const response = await API.get('/users');

    return response.data;
  } catch (error) {
    //console.log(error.response);
    return rejectWithValue(error.response);
  }
});

// Generate unique guest token
export const generateGuestToken = () => {
  return `guest_${uuidv4()}`;
};
